import { ModelBase, observable } from "@shoothill/core";

export class InductionAdminInspectionListModel extends ModelBase<InductionAdminInspectionListModel> {
    public id: string = "";
    @observable
    public inspectionTypeDisplayName: string = "";
    @observable
    public firstName: string = "";
    @observable
    public lastName: string = "";
    @observable
    public serialRegistrationNo: string = "";
    @observable
    public createdDate: Date = new Date();
    @observable
    public projectId: string = "";
    constructor() {
        super();
    }

    fromDto(model: InductionAdminInspectionListDTO): void {
        this.id = model.id;
        this.inspectionTypeDisplayName = model.inspectionTypeDisplayName;
        this.serialRegistrationNo = model.serialRegistrationNo;
        this.firstName = model.firstName;
        this.lastName = model.lastName;
        this.createdDate = model.createdDate;
        this.projectId = model.projectId;
    }
    toDto(model: InductionAdminInspectionListModel): void {
        throw new Error("Method not implemented.");
    }
}

export interface InductionAdminInspectionListDTO {
    id: string;
    inspectionTypeDisplayName: string;
    firstName: string;
    lastName: string;
    serialRegistrationNo: string;
    createdDate: Date;
    projectId: string;
}
